"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _rating = _interopRequireDefault(require("./rating.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var RatingContainer = _styledComponents.default.div.withConfig({
  displayName: "Rating__RatingContainer",
  componentId: "sc-164c2gu-0"
})([""]);

var StarContainer = _styledComponents.default.span.withConfig({
  displayName: "Rating__StarContainer",
  componentId: "sc-164c2gu-1"
})([""]);

var Rating = function Rating(props) {
  var type = props.type,
      rate = props.rate,
      maxRate = props.maxRate,
      starSize = props.starSize,
      starColor = props.starColor,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties;
  var tabIndex = !accessible ? '-1' : '0';

  var populateStars = function populateStars() {
    var stars = [];
    var floor = Math.ceil(rate);
    var maxStar = type === _constant.RATING_TYPE.COMPACT ? floor : maxRate; // eslint-disable-next-line no-plusplus

    for (var i = 1; i <= maxStar; i++) {
      var iconType = _constant.STAR_ICON.EMPTY;

      if (i <= floor) {
        if (i !== floor) {
          iconType = _constant.STAR_ICON.SELECTED;
        } else {
          //  check if rate has decimal
          iconType = rate % 1 === 0 ? _constant.STAR_ICON.SELECTED : _constant.STAR_ICON.HALF;
        }
      }

      var icon = /*#__PURE__*/_react.default.createElement(StarContainer, {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: iconType,
        fontsize: starSize,
        color: starColor,
        accessible: accessible
      }));

      stars.push(icon);
    }

    return stars;
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(RatingContainer, (0, _extends2.default)({
      tabIndex: tabIndex
    }, customProperties, {
      theme: themeContext
    }), populateStars());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Rating.propTypes = _rating.default.PropTypes;
Rating.defaultProps = _rating.default.DefaultProps;
var _default = Rating;
exports.default = _default;